import { text } from 'text';

export const { helpMessages } = text;
